import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { VariantProvider } from './context/VariantContext';

// After a new deployment, old chunk hashes no longer exist on the server.
// A browser with cached HTML referencing stale chunks gets a 404 HTML page
// (MIME type "text/html") instead of JS. Reloading fetches the new index.html.
// Only reload once per session to avoid an infinite reload loop when a chunk
// is genuinely missing rather than stale.
window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem('preloadErrorReloaded')) return;
  sessionStorage.setItem('preloadErrorReloaded', '1');
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <VariantProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </VariantProvider>
);
